import React from 'react'
import { Prompt, withRouter } from 'react-router-dom'

interface INavigationGuard {
  location: Location
  message: string
  isBlocking: boolean
}

const defaultMessage =
  'Are you sure you want to leave this page? Unsaved changes will be lost.'

export const NavigationGuard = withRouter(
  ({ location, message = defaultMessage, isBlocking }: INavigationGuard) => (
    <Prompt
      when={isBlocking}
      message={(nextLocation) =>
        location.pathname === nextLocation.pathname ? true : message
      }
    />
  )
)
